import ReactDom from "react-dom";
import React from "react";
import { Provider, useStaticRendering } from "mobx-react";
import { intercept, decorate, observable } from "mobx";
import { useMemo } from "react";

import LeftHoverMenuStore from "./common/LeftHoverMenu/LeftHoverMenuStore";
import EmailIntegrationsStore from "./EmailIntegrations/EmailIntegrationsStore";
import NotificationStore from "./common/utils/NotificationManager";
import CustomSnackbar from "./common/utils/CustomSnackbar";
import ConfigStore from "./common/stores/ConfigStore";
import PackStore from "./Pack/PackStore";
import UserStore from "./User/UserStore";
import ContainerStore from "./list/ContainerStore";
import ApiClient from "utils/ApiClient";
// import Gamification from './Gamification/index';
// import GamificationStore from "./Gamification/GamificationStore";
import ChatStore from 'app/Chat/stores/ChatStore';
import ChatFunctionsStore from 'app/Chat/stores/ChatFunctionsStore';
import ChatHelpersStore from 'app/Chat/stores/ChatHelpersStore';
import ChatSettingsStore from 'app/Chat/stores/ChatSettingsStore';
import ChatTaskStore from 'app/Chat/stores/ChatTaskStore';
import AssistantStore from 'app/Chat/stores/AssistantStore';
import SheetsNamesUpdaterStore from 'app/Chat/stores/SheetsNamesUpdaterStore';
import OnBoardingStore from 'app/Chat/stores/OnBoardingStore';


// useStaticRendering(typeof window === 'undefined');
class AppStore {
  containerStores = {};
  // for adding from places other than react components
  dialogsToDom = [];

  constructor() {
    this.initStores();
    this.addDefaultDialogs();
    // this.helpScoutInit();
  }

  initStores() {
    this.userStore = new UserStore(this);
    this.packStore = new PackStore(this);
    this.leftHoverMenuStore = new LeftHoverMenuStore(this);
    this.emailIntegrationsStore = new EmailIntegrationsStore(this);
    this.notificationStore = new NotificationStore(this);
    this.configStore = new ConfigStore(this);
    // this.containerStore = new ContainerStore(this);
    // this.gamificationStore = new GamificationStore(this);
    this.chatStore = new ChatStore(this);
    this.chatSettingsStore = new ChatSettingsStore(this)
    this.chatFnsStore = new ChatFunctionsStore(this);
    this.chatHelpersStore = new ChatHelpersStore(this);
    this.chatTaskStore = new ChatTaskStore(this);
    this.assistantStore = new AssistantStore(this);
    this.sheetsNamesUpdaterStore = new SheetsNamesUpdaterStore(this);
    this.onBoardingStore = new OnBoardingStore(this);
    this.currentVisibleListId = '';
    this.socket = null;
    this.clientId = null;
    this.pongReceived = false;
    this.allUserLists = [];
    this.shouldFetchUserLists = true;
    this.is_websocket_enabled = true;
  }

  async fetchInitialData(routerHistory, location) {
    this.routerHistory = routerHistory;
    this.location = location;

    await Promise.all([this.userStore.fetchInitialData(), this.configStore.fetchInitialData()])
    this.fetchUserList();
    this.initSnackBars();
    this.leftHoverMenuStore.loadPacks();
    if (!this.userStore.isLoggedIn && location.pathname != "/login") {
      if (window.location.host.includes("localhost")) {
        routerHistory.push("/login1");
        return;
      }
      window.location = process.env.REACT_APP_API_BASE_URL + '/login';
    } else if (this.userStore.isLoggedIn && location.pathname == "/login") {
      routerHistory.push("/");
    }
  }

  getCurrentListContainerStore(listId) {
    if (!listId) {
      return;
    }
    if (!this.containerStores[listId]) {
      this.containerStores[listId] = new ContainerStore(this, listId);
      this.containerStores[listId].fetchInitialData();
    }

    this.containerStore = this.containerStores[listId]; //TODO: remove this  
    return this.containerStores[listId];
  }

  initSnackBars() {
    this.renderDialog(this.notificationStore, CustomSnackbar);
  }

  // renderGamification() {
  //   this.gamificationStore.checkAndShow();
  //   this.renderDialog(this.gamificationStore, Gamification);
  // }

  // should be called only once
  addDialogToDom(cmp) {
    this.dialogsToDom.push(cmp);
  }

  addDefaultDialogs() {
    // this.addDialogToDom(<AddColumnPopup />);
  }

  //create dialogs store;
  renderDialog(store, Component) {
    let container = document.body.appendChild(document.createElement("div"));

    ReactDom.render(
      <Provider store={store}>
        <Component />
      </Provider>,
      container
    );
  }

  renderDialogWithoutStore(Component, props) {
    let container = document.body.appendChild(document.createElement("div"));

    ReactDom.render(<Component {...props} />, container);
  }

  goToHomePage = () => {
    this.routerHistory.push(`/`);
  }

  async createSheet() {
    try {
      const response = await ApiClient.List.createSheet();
      return response;
    } catch (e) {
      const response = e.response;
      Ext.Msg.alert("Error", response?.message || e.message);
    }
  }

  async fetchUserList() {
    try {
      const { data: { list_id: userListId, list_columns: userListColumns } } = await ApiClient.Items.getUsersList();
      this.userListId = window.userListId = userListId; // global variable for extjs component; todo : remove global references
      this.userListColumns = window.userListColumns = userListColumns;

    } catch (e) {
      const response = e.response;
      Ext.Msg.alert("Error", response?.message || e.message);
    }
  }
  // helpScoutInit() {
  //   let head = document.head || document.getElementsByTagName('head')[0],
  //     helpscoutStyleElement = document.createElement('style');

  //   head.appendChild(helpscoutStyleElement);
  //   helpscoutStyleElement.type = 'text/css';

  //   this.setHelpScoutBeaconHeight = () => {
  //     let bottom = Util.getActiveTab().match('list') ? "85px !important" : "20px !important",
  //       css = `.BeaconFabButtonFrame { bottom: ${bottom} }`;

  //     if (helpscoutStyleElement.firstChild) {
  //       helpscoutStyleElement.firstChild.remove()

  //     }
  //     helpscoutStyleElement.appendChild(document.createTextNode(css));
  //   }
  //   this.setHelpScoutBeaconHeight();
  // }
  // hydrate = (data) => {
  //   if (!data) return

  //   this.lastUpdate = data.lastUpdate !== null ? data.lastUpdate : Date.now()
  //   this.light = !!data.light
  // }
}

decorate(AppStore, {
  currentViewStore: observable,
});

let store = new AppStore();
export default store;

function initializeStore(initialData = null) {
  const _store = store ?? new AppStore();

  // If your page has Next.js data fetching methods that use a Mobx store, it will
  // get hydrated here, check `pages/ssg.js` and `pages/ssr.js` for more details
  if (initialData) {
    _store.hydrate(initialData);
  }
  // For SSG and SSR always create a new store
  if (typeof window === "undefined") return _store;
  // Create the store once in the client
  if (!store) store = _store;

  return _store;
}

export function useStore(initialState) {
  const store = useMemo(() => initializeStore(initialState), [initialState]);
  window.appStore = store;
  return store;
}

// window.appStore = store;
